import React, { useContext, useState } from 'react'
import ReactPlayer from 'react-player'
import SectionKnowMore from '../../molecules/sectionKnowMore/sectionKnowMore'
import SectionLearnMore from '../../molecules/sectionLearnMore/sectionLearnMore'
import ButtonConector from '../../atoms/buttonConector/buttonConector'
import './contentMoreCurV.scss'
import BannerTitles from '../../molecules/bannerTitles/bannerTitles'

import YouTube from 'react-youtube'
import { Context } from '../../../context/app-context'

const ContentMoreCurV = () => {
  const { dispatch } = useContext(Context)

  React.useEffect(() => {
    dispatch({ type: 'clear-modal' })
  }, [])

  const [url, setUrl] = useState('')
  const opts = {
    height: '390',
    width: '640',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  }

  React.useEffect(() => {
    setUrl('fjjWlyZtnoA&ab')
  }, [])

  return (
    <div className="f-content-more">
      <section className="f-content-more__section">
        <BannerTitles section="more" />
      </section>

      <section className="f-content-more__section --section2">
        <p className="f-content-more__text --bold">
          Con la tecnología <span className="--color-pink">Cur-V</span> no hay
          espacio para las manchas
        </p>

        <div className="f-content-more__video-wrapper">
          <div className="f-content-more__decorative --emoji-heart"></div>

          {/*<YouTube*/}
          {/*  videoId={url}*/}
          {/*  // className="f-content-more__video-frame"*/}
          {/*  opts={opts}*/}
          {/*/>*/}
          {/*<ReactPlayer*/}
          {/*  // className="f-content-more__video-frame"*/}
          {/*  url={'https://www.youtube.com/embed/fjjWlyZtnoA?controls=0'}*/}
          {/*  width="100%"*/}
          {/*  height="100%"*/}
          {/*/>*/}

          <iframe
            className="f-content-more__video-frame"
            src="https://www.youtube.com/embed/dT4c-a6jToE"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>

          <div className="f-content-more__decorative --emoji-hashtag"></div>
        </div>
      </section>

      <SectionKnowMore />

      <SectionLearnMore />
    </div>
  )
}

export default ContentMoreCurV
